import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { cmApi } from "./cmApi";

export default function RegisterList() {
  const [registers, setRegisters] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    cmApi
      .listRegisters()
      .then(setRegisters)
      .catch(() => setError("Could not load registers."));
  }, []);

  return (
    <div className="p-6" data-testid="cm-register-list">
      <h1 className="text-xl font-semibold text-slate-800">Registers</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-2">
        {registers.map((r) => (
          <li key={r.slug}>
            <Link
              to={`/compliance/mvp/registers/${r.slug}`}
              className="flex items-center justify-between rounded border border-slate-200 px-4 py-3 hover:border-indigo-400"
              data-testid="cm-register-row"
            >
              <span className="text-slate-800">{r.title}</span>
              <span className="text-xs text-slate-400">{(r.columns || []).length} columns</span>
            </Link>
          </li>
        ))}
      </ul>
      {registers.length === 0 && !error && (
        <p className="mt-4 text-sm text-slate-500">No registers yet.</p>
      )}
    </div>
  );
}
